import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faGlobe,
  faShoppingBag,
} from "@fortawesome/free-solid-svg-icons";
import "../../../css/header.css";
import "../../../css/bootstrap.css";
import "../../../css/element.css";
import "../../../css/flaticon.css";
import "../../../css/font-awesome.css";
import "../../../css/global.css";
import "../../../css/responsive.css";
import "../../../css/style.css";
import { Link } from "react-router-dom";

function Header() {
  const [isToggle, setIsToggle] = useState(false);
  const[showServices,setShowServices]=useState(false)

  const handleToggle = () => {
    setIsToggle(!isToggle);
  };

  return (
    <div className="page-wrapper">
      {/* <div className="preloader"></div> */}
      <header className="main-header">
        <div style={{ padding: "0px 0px" }} className="header-upper">
          <div className="container-fluid clearfix">
            {/* <div className="logo float-left mobile-view-show">
              <Link to='/' className="img-responsive">
                <img src={require("../../../images/logo.png")} alt="" title="" />
              </Link>
            </div> */}
            <div className="menu-area float-right clearfix">
              <nav className="main-menu navbar-expand-lg float-left mobile-view-nav">
                <div className="navbar-header" style={{display:'flex',justifyContent:'space-between'}}>
                  <button
                    onClick={handleToggle}
                    type="button"
                    className="navbar-toggle"
                    data-toggle="collapse"
                    data-target=".navbar-collapse"
                  >
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                  <div className="logo float-left mobile-view-show">
              <Link to='/' className="img-responsive">
                <img src={require("../../../images/logo.png")} alt="" title="" />
              </Link>
            </div>
                </div>
                {isToggle ? (
                  <div
                    style={{ display: "block",marginBottom:'26px'}}
                    className="navbar-collapse collapse clearfix navbar-mobile-view-show"
                  >
                    <ul
                      style={{ paddingLeft: "0px" }}
                      className="navigation clearfix"
                    >
                      <li className="current">
                        <Link to='/'>
                        Home
                        </Link>
                      </li>
                      <li>
                        <Link to='/about-us'>
                    About
                        </Link>
                      </li>
                      <li className="dropdown">
                        <Link onClick={()=>setShowServices(!showServices)} to="#">Services</Link>
                        {showServices?
                        <ul>
                          <li>
                            <Link to="/services/airport-to-door">
                              Airport to Door
                            </Link>
                          </li>
                          <li>
                            <Link to="/services/door-to-airport">
                              Door to Airport
                            </Link>
                          </li>
                          <li>
                            <Link to="/services/international-luggage-shipping">
                              International Luggage Shipping
                            </Link>
                          </li>
                          <li>
                            <Link to="/services/excess-baggage-delivery">
                              Excess Baggage Delivery
                            </Link>
                          </li>
                          <li>
                            <Link to="/services/extra-baggage-cost">
                              Extra Baggage Cost
                            </Link>
                          </li>
                          <li>
                            <Link to="/services/unaccompanied-baggage">
                              Unaccompanied Baggage
                            </Link>
                          </li>
                        </ul>
                        :
                        null
                        }
                      </li>

                      <li className="dropdown">
                        <Link to='/blog'>Blog</Link>
                       
                      </li>
                      <li className="">
                        <Link to='/Faqs'>FAQs</Link>
                      </li>
                      <li>
                      <Link to='/contact-us'>Contact Us</Link>
                      </li>
                    </ul>
                  </div>
                ) : null}
                {/* desktop view  */}
                <div

                  style={{ display: "block"}}
                  className="navbar-collapse collapse clearfix mobile-view-hide"
                >
                  <ul className="navigation clearfix">
                    <li>
                      <a
                        style={{ padding: "4px 0px 0px 0px" }}
                        className="img-responsive"
                      >
                        <img
                          src={require("../../../images/logo.png")}
                          alt=""
                          title=""
                        />
                      </a>
                    </li>
                    <li className="current">
                      <Link to='/'>
                      Home
                      </Link>
                    </li>
                    <li>
                      <Link to='/about-us'>
                      About
                      </Link>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Services</Link>
                      <ul>
                        <li>
                          <Link to="/services/airport-to-door">
                            Airport to Door
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/door-to-airport">
                            Door to Airport
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/international-luggage-shipping">
                            International Luggage Shipping
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/excess-baggage-delivery">
                            Excess Baggage Delivery
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/extra-baggage-cost">
                            Extra Baggage Cost
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/unaccompanied-baggage">
                            Unaccompanied Baggage
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="dropdown">
                      <Link to='/blog'>Blog</Link>
                     
                    </li>
                    <li className="">
                        <Link to='/Faqs'>FAQs</Link>
                      </li>
                    <li>
                    <Link to='/contact-us'>Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </nav>
              <div className="cont-info float-right clearfix mobile-view-hide">
                <div className="curt-button float-left">
                  <a href="#">
                    <FontAwesomeIcon
                      className="shoppingCartIcon"
                      icon={faShoppingBag}
                    />
                  </a>
                </div>
                <div className="contact-button float-right">
                  <a href="#" className="theme-btn btn-style-one">
                    <i className="flaticon-headphones"></i>+91-9999136186
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sticky-header">
          <div className="container-fluid clearfix">
            <Link to="/">
              <div className="logo float-left">
                <a className="img-responsive">
                  <img src={require("../../../images/logo.png")} alt="" title="" />
                </a>
              </div>
            </Link>
            <div className="right-col float-right">
              <nav className="main-menu navbar-expand-lg">
                <div className="navbar-collapse collapse clearfix">
                  <ul className="navigation clearfix">
                    <li className="">
                      <Link to="/">
                      Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/about-us">
                        <a>About</a>
                      </Link>
                    </li>
                    <li className="dropdown">
                      <Link to="#">Services</Link>
                      <ul>
                        <li>
                          <Link to="/services/airport-to-door">
                            Airport to Door
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/door-to-airport">
                            Door to Airport
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/international-luggage-shipping">
                            International Luggage Shipping
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/excess-baggage-delivery">
                            Excess Baggage Delivery
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/extra-baggage-cost">
                            Extra Baggage Cost
                          </Link>
                        </li>
                        <li>
                          <Link to="/services/unaccompanied-baggage">
                            Unaccompanied Baggage
                          </Link>
                        </li>
                      </ul>
                    </li>

                    <li className="dropdown">
                      <Link to="/blog">
                        Blog
                      </Link>
                    </li>
                    <li className="">
                        <Link to='/Faqs'>FAQs</Link>
                      </li>
                    <li>
                      <Link to='/contact-us'>Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
